/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const GIContributionJsonApiModel = {
  id: "",
  amount: "",
  "effective-date": "",
  "transaction-type": "",
  "offering-name": "",
  "offering-status": "",
  description: "",
  units: "",
  "unit-price": "",
  "is-imported": "",
};
